export const SEO_BRAND_NAME = 'preztimer';

export const SEO_DEFAULT_OG_IMAGE = '/og-image.png';

/** Прод-домен. Используется как fallback, если не задан VITE_SITE_URL. */
export const SEO_FALLBACK_SITE_URL = 'https://preztimer.ru';

/** Сохраняем список из прежнего index.html; правка в одном месте. */
export const SEO_KEYWORDS =
  'таймер для презентаций, онлайн таймер, таймер речи, prez timer';

export function seoTitle(pageTitle: string): string {
  return `${pageTitle} — ${SEO_BRAND_NAME}`;
}

/** Нормализованный site URL без завершающего слэша. Пустой env → fallback. */
export function resolveSiteUrl(envSiteUrl: string | undefined): string {
  const trimmed = (envSiteUrl ?? '').trim().replace(/\/$/, '');
  return trimmed || SEO_FALLBACK_SITE_URL;
}

/** База без завершающего слэша или пусто (тогда возвращается относительный путь картинки). */
export function absoluteOgImage(siteBase: string, imagePath: string): string {
  const pathPart = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
  const trimmed = siteBase.trim();
  if (!trimmed) return pathPart;
  return `${trimmed.replace(/\/$/, '')}${pathPart}`;
}
